import { createFileRoute } from "@tanstack/react-router"
import { Conversations } from "modules/conversations/components/List"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { GetConversationsFilterBy, GetConversationsSortBy } from "schema"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(GetConversationsSortBy.shape.sortBy.unwrap())
  .merge(GetConversationsFilterBy)

export const Route = createFileRoute("/_base/_auth/conversations/list")({
  component: Conversations,
  validateSearch: SearchSchema,
})
